import { Theme, defaultTheme } from '@amzn/storm-ui'
import { MobileSetup } from '@amzn/aapn-react-components'

export const overrideTheme = (mobile: MobileSetup): Theme => ({
  ...defaultTheme,
  popover: {
    ...defaultTheme.popover,
    zIndex: 5,
  },
  modal: {
    ...defaultTheme.modal,
    zIndex: 99,
  },
  ...mobile,
})

export const overridePopoverTheme = (theme: Theme): Theme => {
  return {
    ...theme,
    popover: {
      ...theme.popover,
      zIndex: 103,
    },
  }
}
